export const setProfile = (data) => ({
  type: 'SET_PROFILE',
  payload: data,
});

export const setToken = (data) => ({
    type: 'SET_TOKEN',
    payload: data,
});

export const setLoading = (status) => ({
    type: 'SET_LOADING',
    payload: status,
});

export const resetStore = () => ({
    type: 'CLEAR_STORE',
});